import { render, staticRenderFns } from "./ShopDialog.vue?vue&type=template&id=70775fb4&scoped=true&"
import script from "./ShopDialog.vue?vue&type=script&lang=ts&"
export * from "./ShopDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShopDialog.vue?vue&type=style&index=0&id=70775fb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70775fb4",
  null
  
)

export default component.exports